<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Resumen de Retenciones de Clientes</strong>
          </div>
          <b-form>
            <b-form-group label="Fecha Desde" label-for="fechaDesde" :label-cols="labelCols" horizontal>
              <b-form-input
                id="fechaDesde"
                v-model="fechaDesde"
                :state="fechaDesdeValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaDesdeFeedback">
                {{ fechaDesdeInvalidaMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Fecha Hasta" label-for="fechaHasta" :label-cols="labelCols" horizontal>
              <b-form-input
                id="fechaHasta"
                v-model="fechaHasta"
                :state="fechaHastaValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaHastaFeedback">
                {{ fechaHastaInvalidaMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <app-retenciones-tipos
              label="Tipo de Retención"
              labelTodos="Todos los tipos"
              :horizontal="Boolean(true)"
              :nullDisabled="Boolean(false)"
              :labelCols="labelCols"
              :nombre="retencionTipoNombre"
              :lista="retencionesTiposList"
              @updated="retencionTipoActualizado">
            </app-retenciones-tipos>

            <!-- <app-retencion-jurisdiccion
              label="Jurisdiccion"
              :nombre="jurisdiccionIngresosBrutosNombre"
              :lista="jurisdiccionesList"
              :labelCols="labelCols"
              :valido="jurisdiccionValida"
              :msjInvalido="jurisdiccionInvalidaMsj"
              @updated="jurisdiccionActualizada">
            </app-retencion-jurisdiccion> -->
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button" @click.prevent="exportXls"
              >Exportar XLS</b-button
            >
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje :modalMsj="modalMsj" :modalMensaje="modalMensaje" @okAction="okAction" @hiddenAction="hiddenAction" />
  </div>
</template>

<script>
import RetencionesTipos from '../shared/abmSelect.vue'
import Mensaje from '../shared/msjModal.vue'
import { msjModal } from '../../mixins/modalDialogs'
import moment from 'moment'

export default {
  name: 'RetencionesClientesRpt',
  components: {
    appRetencionesTipos: RetencionesTipos,
    appMensaje: Mensaje,
  },
  mixins: [msjModal],
  data() {
    return {
      /* Validacion de datos */
      noValidar: true,
      fechaDesdeValida: null,
      fechaDesdeInvalidaMsj: '',
      fechaHastaValida: null,
      fechaHastaInvalidaMsj: '',

      fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
      fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
      retencionTipo: null,
      retencionTipoNombre: null,

      retencionesTipos: [],
      retencionesTiposList: [],

      labelCols: 2,
    }
  },
  created() {
    this.getDatosAdicionales()
  },
  methods: {
    getDatosAdicionales() {
      const vm = this

      this.$store
        .dispatch('retencionestipos/getList')
        .then(() => {
          vm.retencionesTipos = this.$store.getters['retencionestipos/list']
          vm.retencionesTiposList = this.$store.getters['retencionestipos/selectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de tipos de retención'))
    },
    validate() {},
    exportXls() {
      let execute = true

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false

      let retencionTipoId = 0
      if (this.retencionTipo) {
        if (this.retencionTipo.id) {
          retencionTipoId = this.retencionTipo.id
        }
      }

      let params = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        retencionTipoId,
      }

      if (execute) {
        this.showSpinner()
        this.$store
          .dispatch('retencionesclientes/getRptRetenciones', params)
          .then(() => {
            let exportRpt = Boolean(false)
            let rptRetenciones = this.$store.getters['retencionesclientes/rptRetenciones']

            if (rptRetenciones) {
              if (rptRetenciones.length != 0) {
                exportRpt = Boolean(true)
              }
            }
            if (exportRpt) {
              let title = 'Retenciones de Clientes'
              let fileName = 'retenciones-clientes'
              let format = [
                { titulo: 'Fecha Comprobante', nombre: 'fechaComprobante', formato: 'fecha' },
                // { titulo: 'Cliente', nombre: 'cliente', formato: '' },
                { titulo: 'Agente de Retención', nombre: 'agenteRetencion', formato: '' },
                { titulo: 'Tipo', nombre: 'retencionTipo', formato: '' },
                { titulo: 'Regimen', nombre: 'retencionRegimen', formato: '' },
                { titulo: 'Cod.Jurisdiccion', nombre: 'jurisdiccionCodigo', formato: '' },
                { titulo: 'Jurisdiccion', nombre: 'jurisdiccion', formato: '' },
                { titulo: 'Importe', nombre: 'importe', formato: '' },
              ]

              this.exportXLS(title, fileName, rptRetenciones, format)
            } else {
              this.showErrorMsj('No hay datos para exportar.')
            }
          })
          .catch((error) => this.showErrorMsj(error))
          .finally(() => this.hideSpinner())
      }
    },
    goBack() {},
    retencionTipoActualizado(nombre) {
      this.retencionTipoNombre = nombre
      this.retencionTipo = this.getSelected(this.retencionesTipos, nombre)
    },
  },
}
</script>

<style></style>
